import { inTestEnvironment } from 'shared/javascripts/util/environment'
import { trackElementInteraction } from 'frontend/shared/javascripts/util/analytics'
import { inertiaLinkSelectors } from 'shared/javascripts/util/inertia_paths'

function trackLinkClick(link: HTMLElement) {
  if (link.closest('[data-user-menu], dialog.navigationDrawer')) return

  const href = link.getAttribute('href')
  trackElementInteraction(link, 'click.link', { link: { href } })
}

up.on('up:link:follow', ({ target: link }) => trackLinkClick(link))

// Links into the Inertia app are left to the browser (custom_unpoly.ts), so `up:link:follow` never fires for them.
up.on('click', inertiaLinkSelectors().join(', '), (_event, link) => trackLinkClick(link))

// Unpoly scrolls to in-page targets itself instead of following the link, so `up:link:follow` never fires for
// them. Those that carry an element.id report their click here, in the capture phase: Unpoly stops the click's
// propagation once it has handled the jump.
document.addEventListener(
  'click',
  (event) => {
    const link = (event.target as Element).closest<HTMLAnchorElement>(
      'a[href^="#"]:not([href="#"])[up-id]',
    )
    if (link) {
      trackElementInteraction(link, 'click.link', { link: { href: link.getAttribute('href') } })
    }
  },
  { capture: true },
)

up.on('click', 'a', (event, link: HTMLAnchorElement) => {
  const href = link.href

  const currentHost = window.location.host
  const targetHost = link.host

  if (targetHost !== '' && targetHost !== currentHost) {
    // We want to inspect the event in tests, so we prevent following the external link
    if (inTestEnvironment()) {
      event.preventDefault()
    }
    trackElementInteraction(link, 'externalLink.click', { link: { href } })
  }
})
